module.exports = __webpack_public_path__ + "static/media/visa-greencard.a22e5303.svg";